import script from "./newContact.vue?vue&type=script&setup=true&lang=js"
export * from "./newContact.vue?vue&type=script&setup=true&lang=js"

import "./newContact.vue?vue&type=style&index=0&id=73898322&scoped=true&lang=css"
import "./newContact.vue?vue&type=style&index=1&id=73898322&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73898322"]])

export default __exports__